// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class DocumentDetailController {
   $scope: any
   $window: any
   alerts: any
   config: any
   detailScope: any
   dialog: any
   docDetail: any
   i18n: any
   translationService: any
   useGetForIllReq: any
   utilitiesService: any
   constructor($scope: any, docDetail: any, translationService: any, alerts: any, dialog: any, $window: any, utilitiesService: any, config: any) {
      this.updateShareActionUrls = this.updateShareActionUrls.bind(this)
      this.backToSearch = this.backToSearch.bind(this)
      this.displayDialog = this.displayDialog.bind(this)
      this.displayDialogOld = this.displayDialogOld.bind(this)
      this.openILLRequestLink = this.openILLRequestLink.bind(this)
      this.$scope = $scope
      this.docDetail = docDetail
      this.translationService = translationService
      this.alerts = alerts
      this.dialog = dialog
      this.utilitiesService = utilitiesService
      this.config = config
      this.detailScope = (this.$scope.docDetail = this.docDetail.scope)
      this.detailScope.backToSearch = this.backToSearch
      this.detailScope.displayDialog = this.displayDialog
      this.detailScope.openILLRequestLink = this.openILLRequestLink
      this.detailScope.view = null
      this.$window = $window
      this.i18n = this.translationService
      this.updateShareActionUrls(this.detailScope)

      const resultsConfig = this.config.data.results
      this.$scope.maximumFullTextLinks = resultsConfig.maximumFullTextLinks
      this.$scope.enableAdditionalFullTextLinks = resultsConfig.enableAdditionalFullTextLinks
      this.$scope.displayMultipleFullTextLinks = (this.$scope.maximumFullTextLinks > 1) && this.$scope.enableAdditionalFullTextLinks
      this.useGetForIllReq = this.config.data.document.useGetForIllReq

      const newDocDetail = () => {
         this.detailScope.view = null
         let {
            title
         } = this.detailScope.doc
         const {
            subtitle
         } = this.detailScope.doc
         if (subtitle) { title += ": " + subtitle }
         this.$scope.setWindowTitle(title)
         this.$scope.availabilityDocs = this.detailScope.availabilityDocs
         return this.updateShareActionUrls(this.detailScope)
      }

      this.docDetail.on('new', newDocDetail)

      this.$scope.$on('$destroy', () => {
         return this.docDetail.off('new', newDocDetail)
      })
   }

   updateShareActionUrls(s: any) {
      for (var shareAction of s.socialSharingServices) {
         var href, shareMessage
         var titleText = s.doc.title
         if (s.doc.authors?.length) {
            titleText += ' - ' + s.doc.authors[0].fullname
         }
      
         titleText = this.utilitiesService.removeHithighlightTags(titleText)
         // to avoid very long URLs
         if (titleText.length > 755) {
            titleText = titleText.substring(0, 750) + '...'
         }

         var {
            location
         } = this.$window
         var urlPort = location.port ? ":" + location.port : ""
         var urlBase = location.protocol + "//" + location.hostname + urlPort
         var url = urlBase + "/#!/document?id=" + s.doc.id

         var redirectUri = this.$window.location.href

         if ((shareAction.hrefMobile != null) && this.$window.bowser.mobile) {
            href = shareAction.hrefMobile
         } else { 
            ({
               href
            } = shareAction)
         }

         // @ts-expect-error TS(2365) FIXME: Operator '>' cannot be applied to types 'string' a... Remove this comment to see the full error message
         if (href.indexOf('{URL}' > -1)) {
            shareMessage = this.i18n.translate(this.i18n.translations.SHARE_MESSAGE_X_MESSAGE, {message: titleText})
         } else {
            shareMessage = this.i18n.translate(this.i18n.translations.SHARE_MESSAGE_X_X_MESSAGE_URL, {message: titleText, url})
         }

         var reallyEncode = (text: any) => encodeURIComponent(text).replace(/%20/g, '+')

         shareAction.url = href.replace('{TITLE}', reallyEncode(titleText))
            .replace(/{TEXT}/g, reallyEncode(shareMessage))
            .replace(/{URL}/g, reallyEncode(url))
            .replace(/{REDIRECT_URI}/g, reallyEncode(redirectUri))
      }

      // coffeescript quirk, otherwise it creates a local collection if I leave the shareAction.url as last line...
   }

   backToSearch() {
      this.$scope.viewState.currentView = "search"
      // retain the current state when going 'back to search'; DON'T rerun search from page 1
      this.$scope.setRetainState(true)
      this.$scope.setWindowTitle(this.i18n.translations.RESULTS_FOR + `\"${this.$scope.search.query}\"`)
      return this.docDetail.clearDocument()
   }

   displayDialog(type: any, event: any) {
      this.alerts.resetAlert('citationError')
      this.alerts.resetAlert('citationEmailError')
      const scope = this.$scope
      scope.documents = scope.docDetail.doc
      scope.showExportOptions = true
      const focusBack = function() {
         if (event.currentTarget != null) { event.currentTarget.focus() }
      }
      return this.dialog.displayDialog(type, this.$scope, (modal: any) => scope.close = modal.close).then(focusBack, focusBack)
   }

   displayDialogOld(type: any) {
      // allow for toggling of view
      if (this.detailScope.view === type) { type = null }
      // now set the view
      return this.detailScope.view = type
   }

   openILLRequestLink($event: any, link: any) {
      // When @useGetForIllReq is true, function will do nothing, href default (GET) will open on click 
      if (!this.useGetForIllReq) { // Configurable in CustomizeR
         $event.preventDefault() // prevent href default (GET)
         return this.$scope.openClickTrackLink(link) // call openClickTrackLink (POST)
      }
   }
}



DocumentDetailController.$inject = ['$scope', 'documentDetailService', 'translationService', 'alertService', 'dialogService', '$window', 'utilitiesService', 'configService']

angular.module('summonApp.controllers')
   .controller('DocumentDetailCtrl', DocumentDetailController)
